import React, { useLayoutEffect, useState } from 'react';
import Loadable from 'react-loadable';
import { useHistory, useLocation } from 'react-router-dom';

import LoadableLoading from 'components/LoadableLoading';
import { IProps } from './interfaces';
import { getFilters } from './api';
import { loadSavedSearch } from './savedQuery';

export const path = '/chrona/tracker';

/** Главная с последними фильтрами - для крошки экрана дома. */
export const getSavedPath = () => {
  const saved = loadSavedSearch();
  return saved ? `${path}?${saved}` : path;
};

// На уровне модуля, а не в компоненте: иначе каждый фильтр в адресе пересоздавал бы страницу
// и заново грузил справочники.
const LoadableMap = Loadable.Map({
  loader: {
    page: () => import('./page'),
    i18n: () => import('./ru.json'),
    filters: getFilters,
  },
  loading: LoadableLoading,
  render(loaded: any, loadedProps: {}) {
    const Page = loaded.page.default;

    return <Page i18n={loaded.i18n} filters={loaded.filters} {...loadedProps} />;
  },
});

/**
 * Вход на главную без параметров поднимает последние фильтры до первой загрузки. Только при входе:
 * «Сбросить» до пустого адреса на открытой странице сохранённое не возвращает.
 */
const PageChronaVisitDashboard: React.FC<IProps> = (props) => {
  const history = useHistory();
  const location = useLocation();
  const [restoring, setRestoring] = useState(() => !location.search && !!loadSavedSearch());

  useLayoutEffect(() => {
    if (!restoring) return;
    history.replace({ pathname: location.pathname, search: `?${loadSavedSearch()}` });
    setRestoring(false);
    // Один раз при входе на страницу.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return restoring ? null : <LoadableMap {...props} />;
};

export default PageChronaVisitDashboard;
